export default "__VITE_ASSET__335d8a01__"